<template>
  <div id="app">

    <template v-if="!isMatch && logInEnabled === true">
      <!-- Sekcja tworzenia hasha -->
      <!-- <div class="section">
        <h2 class="section-title">1. Utwórz hash hasła</h2>
        <div class="form-group">
          <label>Wpisz hasło:</label>
          <input
            type="password"
            v-model="password"
            placeholder="Twoje hasło..."
            @keyup.enter="hashPassword"
          >
        </div>
        <button class="btn-primary" @click="hashPassword">
          Zaszyfruj hasło
        </button>
        <div v-if="hashedPassword" class="hash-display">
          <div class="hash-label">Hash (SHA-256):</div>
          <div class="hash-value">{{ hashedPassword }}</div>
        </div>
      </div> -->
      <!-- Sekcja porównywania -->
      <div class="divider"></div>
      <div class="section" style="width: 500px;  margin: 30px auto; display: block;">

        <div class="form-group" style="display: inline;">
          <label style="width:100%;">Enter your verification password:</label>
          <input
            style="width: 50%; margin: 0px auto; padding: 2px 10px;"
            type="password"
            v-model="checkPassword"
            placeholder="Wpisz hasło..."
            @keyup.enter="checkPasswordMatch"
          >
        </div>
        <button class="btn-success" @click="checkPasswordMatch">Check</button>

        <div v-if="isMatch === true" class="result result-success">
          <span style="color:green;">✓ hasło poprawne!</span>
        </div>

        <div v-if="isMatch === false" class="result result-error">
          <span style="color:red;">✗ Incorrect password!</span>
        </div>
      </div>

      <!-- <div>
        <input type="password" v-model="passInput" v-on:keyup.enter="onEnter" placeholder="wpisz hasło i naciśnij ENTER"/>
      </div> -->
    </template>
    <template v-else>
      <HomePage/>
    </template>

  </div>
</template>

<script>
import HomePage from './components/HomePage'

export default {
  name: 'App',
  components: {
    HomePage
  },
  data () {
    return {
      userLog: false,
      passInput: '',
      msg: '',
      password: '',
      hashedPassword: '84c15fc7703a813aa23a2dca5185f2739df012fe9fe761433427d1cfa3e5b416',
      checkPassword: '',
      isMatch: null,
      logInEnabled: process.env.VUE_APP_LOG_IN
    }
  },
  methods: {
    onEnter () {
      this.msg = 'on enter event'
    },
    async hashPasswordString (pwd) {
      const encoder = new TextEncoder()
      const data = encoder.encode(pwd)
      const hashBuffer = await crypto.subtle.digest('SHA-256', data)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
      return hashHex
    },

    async hashPassword () {
      if (!this.password) {
        alert('Wpisz hasło!')
        return
      }
      this.hashedPassword = await this.hashPasswordString(this.password)
      this.isMatch = null
      this.checkPassword = ''
    },

    async checkPasswordMatch () {
      if (!this.checkPassword) {
        alert('Wpisz hasło do sprawdzenia!')
        return
      }
      // if (!this.hashedPassword) {
      //   alert('Najpierw zaszyfruj hasło!')
      //   return
      // }
      const hash = await this.hashPasswordString(this.checkPassword)
      this.isMatch = hash === this.hashedPassword
      if (this.isMatch) {
        sessionStorage.setItem('userLog', this.isMatch)
      }
    }
  },
  created () {
    let userSession = sessionStorage.getItem('userLog')
    if (userSession) {
      this.isMatch = true
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.result {
  width: 320px;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue